export interface AuthResponse {
  jwt: string;
  company_id: string;
  person_id: string;
}

export interface Item {
  name: string;
  id: string;
}

export interface AuthCompanies {
  message?: string;
  companies?: Item[];
}

/**
 * Tags a failure of the Firebase custom-token sign-in, which happens after the
 * backend already answered 200.
 *
 * Carried on `name` rather than a custom `code` field so Sentry groups these
 * separately from every other Error, and matched structurally rather than with
 * `instanceof` because web-b2c mirrors this handling and the two repos cannot
 * share a class. The cost is that `toString()` reads `login-session-error: …`
 * in generic handlers.
 */
export const LOGIN_SESSION_ERROR = 'login-session-error';
